<div class="dialog-container">
  <div class="header">
    @if (data.title) {
      <span class="title">{{ data.title }}</span>
    }
    <oph-x-button class="close-button" (buttonClick)="dialogRef.close()"></oph-x-button>
  </div>

  <div class="image-container">
    <img [src]="data.imageUrl" alt="Photo metric" />
  </div>
</div>
